import { Injectable } from '@angular/core';

import { SalesOrderLine, SalesOrderLinePicking } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderLinePickingService extends TmsWebBaseEditCreateService<SalesOrderLine, SalesOrderLinePicking> {
  constructor() {
    super('SalesOrderLinePicking', $localize`Sales Order Line Picking`);
  }
}
